import React, { useEffect } from 'react'
import Footer from './Footer'
import LandingPage from './LandingPage'
import Sites from './Sites'
import ReactGA from 'react-ga';


const Home = () => {


    useEffect(() => {
        ReactGA.initialize('UA-213399999-2')
        ReactGA.pageview(window.location.pathname + window.location.search);

    }, [])


    return (
        <div id="main">
            <LandingPage />
            <Sites id="sites" />
            <Footer />
        </div>
    )
}

export default Home
